import { Slider } from "@components/atoms/Slider"
import { TFFCenterTile } from "@features/tff/TFFCenterTile"
import { useTFFLocations } from "@features/tff/useTFFLocations"
import { defineBlock, EditableText } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "TFF Next Stops Slider",
  icon: "location",
  tags: ["#featured", "#homepage"],
  flags: {
    fullWidth: true,
    marginRule: "featured-card",
  },
}

export default defineBlock("tff-center/tff-next-stops", (props) => {
  const locations = useTFFLocations()

  return (
    <div data-mixpanel-block="Category Card Row" data-mixpanel-heading="">
      <div className="w-grid mx-auto text-fg">
        <EditableText as="h2" store="heading" defaultValue="Next Stops" className="type-title-m mb-5" plainText />
      </div>
      <Slider arrows gridInsert scrollerClass="flex gap-grid-gutter px-grid-margin-full">
        {locations?.map((loc) => {
          return (
            <TFFCenterTile
              center={loc}
              key={loc.uri}
              className="w-cols-8 sm:w-cols-7 md:w-cols-4 xl:w-cols-3 flex-none"
            />
          )
        })}
      </Slider>
    </div>
  )
})
